jQuery(document).ready(function($) {

    $('.quotes').slick({
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 800,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: '<div class="slick-arrow slick-prev"></div>',
        nextArrow: '<div class="slide-arrow slick-next"></div>',
        arrows: true
      });

});